[
  {
    "id": "simple-birthday",
    "name": "Simple Birthday",
    "orientation": "portrait",
    "categories": [
      "Birthday"
    ],
    "tags": [
      "simple",
      "brand"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "SIMPLE-001",
    "variants": [
      {
        "id": "simple-birthday-5x7p",
        "label": "Default",
        "front": {
          "textFontPolicy": "brand",
          "type": "static",
          "preview": {
            "frontUrl": "",
            "thumbUrl": ""
          },
          "background": {
            "type": "theme",
            "key": "accent"
          },
          "logoSlot": {
            "bounds": {
              "x": 0.35,
              "y": 0.06,
              "width": 0.3,
              "height": 0.12
            },
            "objectFit": "contain"
          },
          "textLayers": [
            {
              "id": "headline",
              "label": "Headline",
              "type": "string",
              "defaultValue": "Happy Birthday",
              "maxLength": 80,
              "bounds": {
                "x": 0.08,
                "y": 0.2,
                "width": 0.84,
                "height": 0.65
              },
              "defaultFontSize": 0.14,
              "fontFamily": "theme:fontPrimary",
              "color": "theme:textOnBlock",
              "textAlign": "center",
              "fontWeight": "bold"
            }
          ],
          "backdrop": {
            "source": "theme",
            "overlayOpacity": 0.35
          }
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600,
          "logoSlot": {
            "bounds": {
              "x": 0.35,
              "y": 0.02,
              "width": 0.3,
              "height": 0.12
            },
            "objectFit": "contain"
          }
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "simple-thank-you",
    "name": "Simple Thank You",
    "orientation": "portrait",
    "categories": [
      "Thank You"
    ],
    "tags": [
      "simple",
      "brand"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "SIMPLE-002",
    "variants": [
      {
        "id": "simple-thank-you-5x7p",
        "label": "Default",
        "front": {
          "textFontPolicy": "brand",
          "type": "static",
          "preview": {
            "frontUrl": "",
            "thumbUrl": ""
          },
          "background": {
            "type": "theme",
            "key": "accent"
          },
          "logoSlot": {
            "bounds": {
              "x": 0.35,
              "y": 0.06,
              "width": 0.3,
              "height": 0.12
            },
            "objectFit": "contain"
          },
          "textLayers": [
            {
              "id": "headline",
              "label": "Headline",
              "type": "string",
              "defaultValue": "Thank You",
              "maxLength": 80,
              "bounds": {
                "x": 0.08,
                "y": 0.2,
                "width": 0.84,
                "height": 0.65
              },
              "defaultFontSize": 0.14,
              "fontFamily": "theme:fontPrimary",
              "color": "theme:textOnBlock",
              "textAlign": "center",
              "fontWeight": "bold"
            }
          ],
          "backdrop": {
            "source": "theme",
            "overlayOpacity": 0.35
          }
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600,
          "logoSlot": {
            "bounds": {
              "x": 0.35,
              "y": 0.02,
              "width": 0.3,
              "height": 0.12
            },
            "objectFit": "contain"
          }
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "simple-congrats",
    "name": "Simple Congratulations",
    "orientation": "portrait",
    "categories": [
      "Congratulations"
    ],
    "tags": [
      "simple",
      "brand"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "SIMPLE-003",
    "variants": [
      {
        "id": "simple-congrats-5x7p",
        "label": "Default",
        "front": {
          "textFontPolicy": "brand",
          "type": "static",
          "preview": {
            "frontUrl": "",
            "thumbUrl": ""
          },
          "background": {
            "type": "theme",
            "key": "accent"
          },
          "logoSlot": {
            "bounds": {
              "x": 0.35,
              "y": 0.06,
              "width": 0.3,
              "height": 0.12
            },
            "objectFit": "contain"
          },
          "textLayers": [
            {
              "id": "headline",
              "label": "Headline",
              "type": "string",
              "defaultValue": "Congrats",
              "maxLength": 80,
              "bounds": {
                "x": 0.08,
                "y": 0.2,
                "width": 0.84,
                "height": 0.65
              },
              "defaultFontSize": 0.14,
              "fontFamily": "theme:fontPrimary",
              "color": "theme:textOnBlock",
              "textAlign": "center",
              "fontWeight": "bold"
            }
          ],
          "backdrop": {
            "source": "theme",
            "overlayOpacity": 0.35
          }
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600,
          "logoSlot": {
            "bounds": {
              "x": 0.35,
              "y": 0.02,
              "width": 0.3,
              "height": 0.12
            },
            "objectFit": "contain"
          }
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "simple-love",
    "name": "Simple Love",
    "orientation": "portrait",
    "categories": [
      "Love"
    ],
    "tags": [
      "simple",
      "brand"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "SIMPLE-004",
    "variants": [
      {
        "id": "simple-love-5x7p",
        "label": "Default",
        "front": {
          "textFontPolicy": "brand",
          "type": "static",
          "preview": {
            "frontUrl": "",
            "thumbUrl": ""
          },
          "background": {
            "type": "theme",
            "key": "accent"
          },
          "logoSlot": {
            "bounds": {
              "x": 0.35,
              "y": 0.06,
              "width": 0.3,
              "height": 0.12
            },
            "objectFit": "contain"
          },
          "textLayers": [
            {
              "id": "headline",
              "label": "Headline",
              "type": "string",
              "defaultValue": "With Love",
              "maxLength": 80,
              "bounds": {
                "x": 0.08,
                "y": 0.2,
                "width": 0.84,
                "height": 0.65
              },
              "defaultFontSize": 0.14,
              "fontFamily": "theme:fontPrimary",
              "color": "theme:textOnBlock",
              "textAlign": "center",
              "fontWeight": "bold"
            }
          ],
          "backdrop": {
            "source": "theme",
            "overlayOpacity": 0.35
          }
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600,
          "logoSlot": {
            "bounds": {
              "x": 0.35,
              "y": 0.02,
              "width": 0.3,
              "height": 0.12
            },
            "objectFit": "contain"
          }
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "simple-get-well",
    "name": "Simple Get Well",
    "orientation": "portrait",
    "categories": [
      "Get Well"
    ],
    "tags": [
      "simple",
      "brand"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "SIMPLE-005",
    "variants": [
      {
        "id": "simple-get-well-5x7p",
        "label": "Default",
        "front": {
          "textFontPolicy": "brand",
          "type": "static",
          "preview": {
            "frontUrl": "",
            "thumbUrl": ""
          },
          "background": {
            "type": "theme",
            "key": "accent"
          },
          "logoSlot": {
            "bounds": {
              "x": 0.35,
              "y": 0.06,
              "width": 0.3,
              "height": 0.12
            },
            "objectFit": "contain"
          },
          "textLayers": [
            {
              "id": "headline",
              "label": "Headline",
              "type": "string",
              "defaultValue": "Get Well Soon",
              "maxLength": 80,
              "bounds": {
                "x": 0.08,
                "y": 0.2,
                "width": 0.84,
                "height": 0.65
              },
              "defaultFontSize": 0.14,
              "fontFamily": "theme:fontPrimary",
              "color": "theme:textOnBlock",
              "textAlign": "center",
              "fontWeight": "bold"
            }
          ],
          "backdrop": {
            "source": "theme",
            "overlayOpacity": 0.35
          }
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600,
          "logoSlot": {
            "bounds": {
              "x": 0.35,
              "y": 0.02,
              "width": 0.3,
              "height": 0.12
            },
            "objectFit": "contain"
          }
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "simple-thinking-of-you",
    "name": "Simple Thinking of You",
    "orientation": "portrait",
    "categories": [
      "Thinking of You"
    ],
    "tags": [
      "simple",
      "brand"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "SIMPLE-006",
    "variants": [
      {
        "id": "simple-thinking-of-you-5x7p",
        "label": "Default",
        "front": {
          "textFontPolicy": "brand",
          "type": "static",
          "preview": {
            "frontUrl": "",
            "thumbUrl": ""
          },
          "background": {
            "type": "theme",
            "key": "accent"
          },
          "logoSlot": {
            "bounds": {
              "x": 0.35,
              "y": 0.06,
              "width": 0.3,
              "height": 0.12
            },
            "objectFit": "contain"
          },
          "textLayers": [
            {
              "id": "headline",
              "label": "Headline",
              "type": "string",
              "defaultValue": "Thinking of You",
              "maxLength": 80,
              "bounds": {
                "x": 0.08,
                "y": 0.2,
                "width": 0.84,
                "height": 0.65
              },
              "defaultFontSize": 0.14,
              "fontFamily": "theme:fontPrimary",
              "color": "theme:textOnBlock",
              "textAlign": "center",
              "fontWeight": "bold"
            }
          ],
          "backdrop": {
            "source": "theme",
            "overlayOpacity": 0.35
          }
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600,
          "logoSlot": {
            "bounds": {
              "x": 0.35,
              "y": 0.02,
              "width": 0.3,
              "height": 0.12
            },
            "objectFit": "contain"
          }
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  }
]